import { setDefaultFiltersBeforeEnter } from 'asteroid'

export default [
  {
    name: 'FunnelsList',
    path: 'funnels',
    beforeEnter: setDefaultFiltersBeforeEnter,
    component: () => import('pages/funnels/FunnelsList.vue')
  }
]
